import axios from 'axios'
import { VueAxios } from './axios'
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  // baseURL: 'https://official-api.redkylin.info',
  // baseURL: 'https://api-inet.redkylin.info',
  baseURL: 'https://api-us.redkylin.info',
  timeout: 100000 // 请求超时时间
})
// 异常拦截处理器
const errorHandler = (error) => {
  let data = {}
  if (error.response) {
    data = error.response.data
    if ([400, 403, 500].includes(error.response.status)) {
      console.log(data)
    }
  }
  return Promise.reject(data)
}
// 请求 interceptor
request.interceptors.request.use((config) => {
  config.headers['Content-Type'] = 'application/json; charset=utf-8'
  return config
}, errorHandler)

// 响应 interceptor
request.interceptors.response.use((response) => {
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export { installer as VueAxios, request as axios }
